define('SageDotCom/DataLayer/Events/Forms/navigationButtonClick',['jquery', 'SageDotCom/DataLayer/Events/eventBase'], function ($, EventBase) {

    function FormNavigationEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = "form_navigation"; // overwrite name
    }

    FormNavigationEvent.prototype = Object.create(EventBase.prototype);

    FormNavigationEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope) {
        var eventData = {
            "event_name": this.getName(), //event name
            "event_non-int": "0", //non interaction point
            "event_category": "contact", //top line category
            "event_action": "form page navigation complete" //specific action
        };

        if (scope) {
            var lbl = "(not set)";         
            const location = this.getLocation(scope);

            $(scope).find("input[type=submit]").each(function() {
                if ($(this).val().toLowerCase() !== "submit")
                    lbl = $(this).val();
            });

            eventData = $.extend(eventData, {
                'event_label': this.cleanseString(lbl),
                'event_name_level_1': this.getId(scope),
                'event_name_level_2': $(scope).closest("form").attr("id"),
                'event_name_level_3': "(not set)",
                'event_name_level_4': location
            });
        }

        return eventData;
    }

    return new FormNavigationEvent();
}); 
